import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiWizardV3} from './api.wizardsV3.service';
import {map} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class WizardsV3Service {

  private readonly token = 'bi4kspH6T1h2qi__vq1l2wEvJDrUKOmOOM8FKZOP3RiYnhhWpwxncyj2ZZ2LN2ze';

  private readonly secureHeaderKey = 'LCG-Wizard-v3-Request-Key';

  constructor(
    private apiV3: ApiWizardV3,
    private translate: TranslateService
  ) {}

  public getWizardsWidgetCount(data): Observable<any> {
    return this.apiV3.post('/v1/api/count', {
      body: this.processBody(data),
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json',
        'X-SECURE-HEADER-KEY': this.secureHeaderKey
      }
    }).pipe(
      map((i: any) => {
        if(i.items) {
          Object.keys(i.items).forEach(key => {
            if (i.items[key].csr_type) {
              i.items[key]['products'] = i.items[key].csr_type;
            }
          });
        }

        return i;
      })
    );
  }

  public getWizardsLeads(data): Observable<any> {
    return this.apiV3.post('/v1/api/list', {
      body: this.processBody(data),
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json',
        'X-SECURE-HEADER-KEY': this.secureHeaderKey
      }
    });
  }

  private processBody(body: any) {
    const lang = this.translate.currentLang || 'en';
    body.language = lang;
    return JSON.stringify(body);
  }
}

